import React from 'react'
import bannerImg from '../../assets/images/b2b-banner.jpg'


function MobileAppBanner() {
    return (
        <div className='container-fluid mt-5 px-0'>
            <img className='w-100'  src={bannerImg} />
        </div>
    )
}

export default MobileAppBanner
